import React, { useEffect, useState } from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import LoadingBox from "common/components/LoadingBox";
import * as api from "core-module/services/api";
import store from "store";

import AutoPaymentSummary from "./AutoPaymentSummary.jsx";
import AutoPaymentNameOnCard from "./AutoPaymentNameOnCard.jsx";
import Declined from "./Declined.jsx";
import EFTPage from "./EFTPage.jsx";
import AddEFTpage from "./AddEFTPage.jsx";
import { isIosDevice } from "../../deviceInfo";
import { Plugins } from "@capacitor/core";
import { useHistory } from "react-router-dom";
import { ApiError } from "../../core-module/services/error";

const { Browser } = Plugins;

const AutoPayment = (props) => {
  let history = useHistory();
  const [page, setPage] = useState("summary");
  const [nameOnCard, setNameOnCard] = useState("");
  const [message, setMessage] = useState("");
  const [locationParams, setLocationParams] = useState("");
  const [historyState, setHistoryState] = useState({});

  const storeState = store.getState();
  var userid = storeState.services.ids.user;

  //works for ios
  useEffect(() => {
    if (history.location.state && historyState != history.location.state) {
      setHistoryState(history.location.state);
      var cctoken = history.location.state["cctoken"];
      var result = history.location.state["result"];
      const sessionID = window.sessionStorage.getItem("sessionID");
      const sessionToken = window.sessionStorage.getItem("sessiontoken");
      if (
        userid !== "" &&
        sessionID &&
        sessionToken &&
        cctoken &&
        result == "approved"
      ) {
        afterApproval(userid, sessionID, sessionToken, cctoken);
      }
      if (result == "cancelled") {
        setPage("summary");
      }
      if (result == "denied") {
        setPage("declined");
      }
    }
  }, [history]);

  //Works for web/android
  useEffect(() => {
    let locationParameters = props.location.search;
    if (
      locationParameters != null &&
      locationParameters != "" &&
      props.location.search != locationParams
    ) {
    
      setLocationParams(locationParameters);
      const messageJSON = decodeURI(
        getQueryVariable(locationParameters, "message")
      );
      const message = JSON.parse(messageJSON);

      let result = decodeURI(getQueryVariable(locationParameters, "?result"));
      let cctoken = message.ssl_token;
      const sessionID = window.sessionStorage.getItem("sessionID");
      const sessionToken = window.sessionStorage.getItem("sessiontoken");

      history.push(
        history.location.pathname,
        history.location.state
      );

      if (
        userid !== "" &&
        sessionID &&
        sessionToken &&
        cctoken &&
        result == "approved"
      ) {
        afterApproval(userid, sessionID, sessionToken, cctoken);
      }
    }
  }, [props.location.search]);

  function goToCreditCard() {
    setPage("creditcard");
  }
  function goToEFT(specificMessage = "") {
    setMessage(specificMessage);
    setPage("eft");
  }
  function goToAddEFT() {
    setPage("addeft");
  }
  function backToMainScreen(specificMessage = "") {
    setMessage(specificMessage);
    setPage("summary");
  }

  function getQueryVariable(query, variable) {
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  }

  async function afterApproval(userid, sessionID, sessionToken, cctoken) {
    setPage("loading");
    let res;
    try {
      res = await api.post("user." + userid + "/cctoken." + sessionID, {
        sessiontoken: sessionToken,
        cctoken: cctoken,
      });
    } catch (e) {
      if (e instanceof ApiError) {
        alert(e.message);
        console.log(e.message);
        return false;
      }
    }

    const isIos = await isIosDevice();
    if (res.success) {
      if (isIos) {
        setPage("summary");
      } else {
        window.location.reload();
        setPage("summary");
      }
    } else {
      window.alert(res.message);
    }
  }

  async function creditCardAfterName() {
    if (nameOnCard.trim().length < 1) {
      window.alert(
        "Please fill name on card before continuing. If prepaid card, write 'prepaid'"
      );
      return;
    }
    setPage("loading");
    const storeState = store.getState();

    if (storeState.services.ids.user === "") {
      throw new Error("Session user null");
    }

    const userid = storeState.services.ids.user;
    const resJSON = await api.fetchApi(
      "?target=user." + userid + "/cctoken&nameoncard=" + nameOnCard
    );
    const res = await resJSON.json();

    if (res.error) {
      window.alert(res.message);
      return;
    }

    if (!("list" in res)) {
      throw new Error("List not in cctoken response");
    }

    // const paymentFields = {
    //   ssl_txn_auth_token: sessionToken,
    // };

    // const callback = {
    //   onError: function (error) {
    //     throw new Error(error);
    //   },
    //   onCancelled: function () {
    //     setPage("summary");
    //     console.log("cancelled");
    //   },
    //   onDeclined: function (response) {
    //     setPage("declined");
    //     console.log(response);
    //   },
    //   onApproval: function (response) {
    //     setPage("loading");
    //     afterApproval(userid, sessionID, sessionToken, response);
    //   },
    // };

    const isIos = await isIosDevice();
    if (isIos) {
      if (!history.location.state) {
        window.sessionStorage.setItem("sessionID", res.list[0].id);
        window.sessionStorage.setItem("sessiontoken", res.list[0].sessiontoken);
        let code = process.env.NODE_ENV == "development" && !isIos ? 5 : 4;
        await Browser.open({
          url:
            "https://combobulator.mcsnet.ca/addcc.php?code=" +
            code.toString() +
            "&sessiontoken=" +
            encodeURIComponent(res.list[0].sessiontoken),
        });
        setPage("loading");
      }
    } else {
      if (res) {
        window.sessionStorage.setItem("sessionID", res.list[0].id);
        window.sessionStorage.setItem("sessiontoken", res.list[0].sessiontoken);
        const redirectURL =
          "https://combobulator.mcsnet.ca/addcc.php?code=4&sessiontoken=" +
          encodeURIComponent(res.list[0].sessiontoken);
        console.log("redirecting");
        window.open(redirectURL, "_self");
        setPage("loading");
      }
    }
  }

  return (
    <GridContainer justify="center">
      <GridItem xs={12} md={12} lg={12}>
        {page === "summary" ? (
          <AutoPaymentSummary
            message={message}
            goToCreditCard={goToCreditCard}
            goToEFT={goToEFT}
            onExpiryChange={() => window.location.reload()}
          />
        ) : null}
        {page === "declined" ? <Declined /> : null}
        {page === "creditcard" ? (
          <AutoPaymentNameOnCard
            backToMainScreen={backToMainScreen}
            setNameOnCard={setNameOnCard}
            nameOnCard={nameOnCard}
            handleNext={creditCardAfterName}
          />
        ) : null}
        {page === "eft" ? (
          <EFTPage
            backToMainScreen={backToMainScreen}
            goToAddEFT={goToAddEFT}
          />
        ) : null}
        {page === "addeft" ? (
          <AddEFTpage backToMainScreen={backToMainScreen} goToEFT={goToEFT} />
        ) : null}
        {page === "loading" ? <LoadingBox /> : null}
      </GridItem>
    </GridContainer>
  );
};

export default AutoPayment;
